import React from "react";
import PageHeader from "../components/PageHeader";
import Portfolio from "../components/Portfolio";
import useSEO from "../lib/seo";

export default function ProjectsPage() {
  useSEO({
    title: "Projects | NHT Housing, PAHO Smart Hospital & More · LNZ Jamaica",
    description:
      "Explore LNZ's portfolio: NHT Housing Development (Clarendon & Manchester), PAHO Smart Hospital renovations, Signal Hill Tobago residences, and Jamaica North–South Highway slope analysis.",
    path: "/projects",
    keywords:
      "LNZ projects, NHT housing Clarendon Manchester, PAHO Smart Hospital Jamaica, Signal Hill Tobago, Jamaica North South Highway, Caribbean construction portfolio",
  });
  return (
    <div data-testid="projects-page">
      <PageHeader
        overline="FEATURED WORK"
        title="Our projects across "
        accent="Jamaica & the Caribbean."
        description="From NHT housing in Clarendon to PAHO Smart Hospital renovations and structural design in Tobago — explore the work that defines LNZ."
      />
      <Portfolio
        showFilters={true}
        overline="PROJECT PORTFOLIO"
        title="Built. Engineered. Delivered."
        subtitle="Filter by category to explore housing, healthcare, residential and infrastructure projects across the region."
      />
    </div>
  );
}
